<template>
  <div class="search navbar-item">
    <div :class="!isShowNav?'on':''" class="search-wrapper">
      <div :class="!isShowNav?'cloak cloak-right border-left':'cloak cloak-right'" @click="searchOn(value)" class="is-hidden-touch geekbang-icon">&#xe64c;</div>
      <div :class="!isShowNav?'cloak cloak-left border-right':'cloak cloak-left'" @click="searchOff()" class="is-hidden-touch geekbang-icon">&#xe605;</div>
      <input type="text" placeholder="请输入你要搜索的关键词" :class="isShowNav?'opacity':''" ref="inputBtn" v-model="value" class="is-hidden-touch" @keyup.13="searchOn(value)">
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isShowNav: true,
      value: ''
    }
  },
  methods: {
    // 搜索按钮
    searchOn (value) {
      if (value && !this.isShowNav) {
        // 发起请求 并跳转页面
        // alert("对"+value+"发起请求")
        let url = 'http://s.geekbang.org/search/c=0/k=' + value + '/t='
        window.open(url)
        this.value = ''
      } else {
        // 把导航栏取消
        this.isShowNav = !this.isShowNav
        this.$emit('searchDisplay')
      }
    },
    searchOff () {
      this.isShowNav = !this.isShowNav
      this.$emit('searchDisplay')
    }
  }
}
</script>
<style lang="sass" scoped>
@import "../../style/variable"
@import '../../style/bulma/base/_all'
@import "../../style/generic"
@import "../../style/layout"
@import "../../style/component"
@import "../../style/icon/iconfont.css"

.search
  position: relative
  height: 100%
  align-items: center
  div.search-wrapper
    background-color: #fff
    position: absolute
    width: 28px
    height: 28px
    overflow: hidden
    line-height: 28px
    border-radius: 14px
    padding: 0 0
    right: 0
    top: -12px
    transition: width .5s
    .cloak
      position: absolute
      width: 28px
      height: 28px
      z-index: 1
      text-align: center
    .cloak-left
      background-color: #fff
      background-size: 40%
      left: 0
      cursor: pointer
    .cloak-right
      background-color: #fff
      right: 0
      z-index: 2
      font-size: 14px
      cursor: pointer
    input
      border-radius: 14px
      background-color: #fff
      border: none
      padding: 5px 38px
      width: 30rem
      height: 28px
      position: absolute
      outline: none

</style>


// WEBPACK FOOTER //
// pc.vue?8ae220aa